import(/* webpackMode: "eager" */ "/app/src/app/components/404/styles/fanduel.scss");
